//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../paginationCommon.scss'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'

// @ADD Component types
interface IPaginationCommonLayoutProps {
  version?: 'v1' | 'v2'
  data: IPagination
  onNext: () => void
  onPrevious: () => void
  onPageNumber: (page: number) => void
  totalPages: any
}

const PaginationCommonLayout: React.FC<IPaginationCommonLayoutProps> = (props) => {

  const { t } = useTranslation()
  const layoutVersion = props.version || 'v1'

  const renderComponent = () => {
    if (layoutVersion === 'v1') {
      return (
        <nav className='float-right'>
          <ul className='pagination'>
            <li className={`page-item ${props.data.page === 1 ? 'disabled' : ''}`}>
              <button className='page-link' aria-label='Previous' onClick={props.onPrevious}>
                <span aria-hidden='true'>&laquo;</span>
              </button>
            </li>

            <li className='num'>
              {`${(props.data.page - 1) * props.data.perPage + 1}-${
                props.data.perPage * props.data.page > props.data.total ? props.data.total : props.data.perPage * props.data.page
              } ${t('components.pagination.of')} ${props.data.total} ${t('components.pagination.registers')}`}
            </li>

            <li className={`page-item ${props.totalPages.length === props.data.page ? 'disabled' : ''}`}>
              {' '}
              <button className='page-link' aria-label='Next' onClick={props.onNext}>
                <span aria-hidden='true'>&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      )
    } else if (layoutVersion === 'v2') {
      return (
        <nav className='float-right'>
          <ul className='pagination'>
            <li className='num'>
              {`${(props.data.page - 1) * props.data.perPage + 1}-${
                props.data.perPage * props.data.page > props.data.total ? props.data.total : props.data.perPage * props.data.page
              } ${t('components.pagination.of')} ${props.data.total}`}
            </li>

            <li className={`page-item ${props.data.page === 1 ? 'disabled' : ''}`}>
              <button className='page-link' aria-label='Previous' onClick={props.onPrevious}>
                <IoIosArrowBack />
              </button>
            </li>

            <li className={`page-item ${props.totalPages.length === props.data.page ? 'disabled' : ''}`}>
              <button className='page-link' aria-label='Next' onClick={props.onNext}>
                <IoIosArrowForward />
              </button>
            </li>
          </ul>
        </nav>
      )
    } else {
      return null;
    }
  }

  return(
    <>
      {renderComponent()}
    </>
  )
}

export default PaginationCommonLayout
